var _defs, _text, _path, _path2, _rect, _polygon, _polygon2, _polygon3, _polygon4, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect8, _rect9, _rect10, _rect11, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _polygon5, _polygon6, _path33, _rect12, _polygon7, _rect13, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _rect14, _polygon8, _polygon9, _path99, _path100, _path101, _polygon10, _path102, _path103, _g, _path104, _path105, _path106, _path107, _rect15, _path108, _path109, _g2, _path110, _path111, _path112, _path113, _line, _path114, _line2, _line3, _path115, _path116, _path117, _line4, _ellipse, _path118, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _rect22, _rect23, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _polygon11, _polygon12, _path148, _rect24, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _polygon13, _polygon14, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _circle, _circle2, _circle3, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _polygon15, _path185, _path186;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemporal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365,247.35s.72,13.31-1.48,19.5-5.16,10.3-5.16,13.31,4.79,6.63,4.79,12.5-10.66,34.21-13.6,39.73-1.9,7.35-5.52,7.71-12.86-4-12.86-4-5.53.73-6.26,2.93-2.58,9.94-2.58,9.94L268.63,325a53.7,53.7,0,0,0,11-18.76c3.31-10.66-1.9-27.22-1.9-27.22s-5.15-38.6,18.38-49.64,57.74-4,63.27,1.48S365,247.35,365,247.35Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.6,332.31l-1.35.93C251.08,336.8,232,350,217.52,361.37c-16.92,13.3-18,37.88-18.76,57s-13.08,138.17-16,152.88,23.38,18.48,48.75,22.16,58.1-.36,73.91-7.71,19.5-7,19.5-15.09.37-26.48.37-27.94,11.4-91.57,10.66-118.05,1.48-40.82-4.77-54.07S309.09,347,288.13,340,257.6,332.31,257.6,332.31Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.74,408.05s-10.31,14-13.61,25,.72,26.84,1.9,30.52S350,583.11,356.21,594.52s13.3,12.12,18.39,10.3,64.36-44.13,66.53-46.34,12.14-10.66,12.14-10.66,1.9-11.78-6.25-18-12.15-2.94-12.15-2.94l-51.48,14s-29.05-100-32.31-119.14,1.9-18-8.46-28.32a144.43,144.43,0,0,0-22.81-18.06",
    fill: "none"
  })), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, ::after, ::before { box-sizing: border-box; }\nimg, svg { vertical-align: middle; }\n"), /*#__PURE__*/React.createElement("style", {
    xmlns: "http://www.w3.org/1999/xhtml"
  }, "*, body, html { -webkit-font-smoothing: antialiased; }\nimg, svg { max-width: 100%; }\n"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(432.88 341.45)",
    fontSize: 12,
    fontFamily: "MyriadPro-Regular, Myriad Pro"
  }, "v1")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.86,433.34S164.11,543,271.61,595.52s235.67,28.74,340,12.14S782.47,514.53,775.38,423.3s-91.23-99.19-155.52-190.06S552.27,108.3,448.8,67,212.31,96,161,219.2,136.86,433.34,136.86,433.34Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.86,433.34S164.11,543,271.61,595.52s235.67,28.74,340,12.14S782.47,514.53,775.38,423.3s-91.23-99.19-155.52-190.06S552.27,108.3,448.8,67,212.31,96,161,219.2,136.86,433.34,136.86,433.34Z",
    fill: "#fff",
    opacity: 0.7,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M544,325.25a.5.5,0,0,1-.5-.5,75.5,75.5,0,0,0-151,0,.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5,76.5,76.5,0,0,1,153,0A.5.5,0,0,1,544,325.25Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 620.9,
    y: 559.37,
    width: 12.24,
    height: 61.85,
    fill: "#9ea0a3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "686.3 621.2 686.3 516.52 633.14 559.38 633.14 621.2 686.3 621.2",
    fill: "#b3b3b3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "647.89 570.3 157.61 570.3 157.42 566.31 725.42 506.67 725.42 510.7 647.89 570.3",
    fill: "#9ea0a3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "647.89 566.27 157.61 566.27 281.3 506.67 725.42 506.67 647.89 566.27",
    fill: "#e1e1e2"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "647.89 570.3 647.89 566.27 725.42 506.67 725.42 510.7 647.89 570.3",
    fill: "#b3b3b3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M373.94,519.5H311.06a1,1,0,0,1-.43-1.9l12.92-6.23a1.09,1.09,0,0,1,.44,0h58a1,1,0,0,1,.61,1.78l-8.1,6.22A1,1,0,0,1,373.94,519.5Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 343.93,
    y: 472.12,
    width: 11.56,
    height: 44.04,
    fill: "#b3b3b3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 342.12,
    y: 472.12,
    width: 15.17,
    height: 31.97,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 256.76,
    y: 325.62,
    width: 191.35,
    height: 149.67,
    fill: "#0071f2",
    "data-primary": "true"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 256.76,
    y: 325.62,
    width: 191.35,
    height: 149.67,
    fill: "#fff",
    opacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 266.98,
    y: 333.62,
    width: 170.89,
    height: 133.67,
    fill: "#ebebeb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 267.02,
    y: 348.33,
    width: 171,
    height: 19.87,
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M431.77,364.92H317.87V351.48h113.9Zm-113.4-.5h112.9V352H318.37Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M309.4,388H274.06V370.6H309.4Zm-34.84-.5H308.9V371.1H274.56Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M355.1,383H336.66v-7.34H355.1Zm-17.94-.5H354.6v-6.34H337.16Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M380.7,383H362.27v-7.34H380.7Zm-17.93-.5H380.2v-6.34H362.77Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M404.92,383H386.49v-7.34h18.43Zm-17.93-.5h17.43v-6.34H387Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M430.8,383H412.37v-7.34H430.8Zm-17.93-.5H430.3v-6.34H412.87Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M430.8,445H274.06V390.89H430.8Zm-156.24-.5H430.3V391.39H274.56Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 269.83,
    y: 417.7,
    width: 165.19,
    height: 0.5,
    transform: "translate(-116.53 136.94) rotate(-18.93)",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 352.18,
    y: 335.36,
    width: 0.5,
    height: 165.19,
    transform: "translate(-157.29 615.64) rotate(-71.06)",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 274.02,
    y: 452.18,
    width: 148,
    height: 0.5,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 274.02,
    y: 463.5,
    width: 134.93,
    height: 0.5,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M324.27,356.34a1.37,1.37,0,0,1,.59.6,2.09,2.09,0,0,1,.21,1v2.4h-.52V358a1.42,1.42,0,0,0-.33-1,1.18,1.18,0,0,0-.91-.35,1.22,1.22,0,0,0-.94.37,1.53,1.53,0,0,0-.36,1.1v2.24h-.52v-5.55H322v2.15a1.45,1.45,0,0,1,.58-.57,1.81,1.81,0,0,1,.85-.2A1.72,1.72,0,0,1,324.27,356.34Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M326.91,356.67v2.54a.67.67,0,0,0,.15.51.66.66,0,0,0,.5.15H328v.45h-.56a1.18,1.18,0,0,1-.83-.26,1.16,1.16,0,0,1-.27-.85v-2.54h-.57v-.45h.57v-1h.53v1H328v.45Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M329.58,356.67v2.54a.72.72,0,0,0,.14.51.71.71,0,0,0,.51.15h.47v.45h-.56a1,1,0,0,1-1.09-1.11v-2.54h-.57v-.45h.57v-1h.53v1h1.12v.45Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M332.7,356.44a1.84,1.84,0,0,1,1-.28,2,2,0,0,1,1,.26,1.85,1.85,0,0,1,.7.74,2.38,2.38,0,0,1,.25,1.1,2.45,2.45,0,0,1-.25,1.11,1.79,1.79,0,0,1-.7.74,1.9,1.9,0,0,1-1,.27,1.81,1.81,0,0,1-1-.28,1.64,1.64,0,0,1-.63-.68v2.83h-.51v-6h.51v.9A1.68,1.68,0,0,1,332.7,356.44Zm2.23.94a1.41,1.41,0,0,0-.55-.56,1.56,1.56,0,0,0-.78-.2,1.51,1.51,0,0,0-.76.2,1.4,1.4,0,0,0-.55.58,1.91,1.91,0,0,0,0,1.74,1.4,1.4,0,0,0,.55.58,1.51,1.51,0,0,0,.76.2,1.56,1.56,0,0,0,.78-.2,1.47,1.47,0,0,0,.55-.58,2,2,0,0,0,0-1.76Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M336.44,357a.39.39,0,0,1-.11-.28.38.38,0,1,1,.76,0,.39.39,0,0,1-.11.28.39.39,0,0,1-.54,0Zm0,3.26a.39.39,0,0,1-.11-.28.38.38,0,1,1,.76,0,.39.39,0,0,1-.11.28.39.39,0,0,1-.54,0Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M340.61,361.56l-2.44-8.29h.53l2.43,8.29Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M345.13,361.56l-2.45-8.29h.54l2.42,8.29Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M352.44,356.22l-1.28,4.1h-.53l-1.13-3.44-1.13,3.44h-.53l-1.28-4.1h.53l1,3.56,1.14-3.56h.53l1.13,3.57,1-3.57Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M358.54,356.22l-1.28,4.1h-.52l-1.13-3.44-1.13,3.44h-.54l-1.28-4.1h.54l1,3.56,1.15-3.56h.52l1.14,3.57,1-3.57Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M364.65,356.22l-1.28,4.1h-.53l-1.13-3.44-1.13,3.44h-.53l-1.28-4.1h.53l1,3.56,1.15-3.56H362l1.13,3.57,1-3.57Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M365.18,360.24a.39.39,0,0,1-.11-.28.38.38,0,1,1,.76,0,.39.39,0,0,1-.11.28.39.39,0,0,1-.54,0Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M366.74,357.16a1.85,1.85,0,0,1,.7-.74,2,2,0,0,1,1-.26,1.79,1.79,0,0,1,1,.27,1.61,1.61,0,0,1,.64.68v-2.34h.52v5.55h-.52v-.92a1.55,1.55,0,0,1-.62.7,1.81,1.81,0,0,1-1,.28,1.93,1.93,0,0,1-1-.27,1.77,1.77,0,0,1-.69-.74,2.33,2.33,0,0,1-.25-1.11A2.26,2.26,0,0,1,366.74,357.16Zm3.12.24a1.54,1.54,0,0,0-.55-.58,1.58,1.58,0,0,0-.77-.2,1.56,1.56,0,0,0-.78.2,1.33,1.33,0,0,0-.54.56,2,2,0,0,0,0,1.76,1.38,1.38,0,0,0,.54.58,1.56,1.56,0,0,0,.78.2,1.58,1.58,0,0,0,.77-.2,1.54,1.54,0,0,0,.55-.58,2,2,0,0,0,0-1.74Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M372.54,360.12a1.92,1.92,0,0,1-.73-.74,2.42,2.42,0,0,1,0-2.22,2,2,0,0,1,.74-.74,2.11,2.11,0,0,1,1-.26,2.14,2.14,0,0,1,1,.26,2,2,0,0,1,.74.74,2.3,2.3,0,0,1,.26,1.11,2.23,2.23,0,0,1-.27,1.11,1.88,1.88,0,0,1-.74.74,2.15,2.15,0,0,1-1.05.26A2.07,2.07,0,0,1,372.54,360.12Zm1.78-.39a1.35,1.35,0,0,0,.56-.55,2.08,2.08,0,0,0,0-1.82,1.32,1.32,0,0,0-.55-.55,1.58,1.58,0,0,0-1.5,0,1.32,1.32,0,0,0-.55.55,2.08,2.08,0,0,0,0,1.82,1.32,1.32,0,0,0,.55.55,1.43,1.43,0,0,0,.74.19A1.49,1.49,0,0,0,374.32,359.73Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M382.63,356.6a1.77,1.77,0,0,1,.46,1.32v2.4h-.52V358a1.47,1.47,0,0,0-.32-1,1.12,1.12,0,0,0-.88-.35,1.16,1.16,0,0,0-.92.38,1.59,1.59,0,0,0-.35,1.11v2.22h-.51V358a1.47,1.47,0,0,0-.32-1,1.13,1.13,0,0,0-.89-.35,1.16,1.16,0,0,0-.92.38,1.59,1.59,0,0,0-.34,1.11v2.22h-.53v-4.1h.53v.71a1.29,1.29,0,0,1,.55-.58,1.78,1.78,0,0,1,1.73,0,1.44,1.44,0,0,1,.59.75,1.36,1.36,0,0,1,.56-.74,1.67,1.67,0,0,1,.91-.26A1.58,1.58,0,0,1,382.63,356.6Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M384.26,357.16a1.85,1.85,0,0,1,.7-.74,2,2,0,0,1,1-.26,1.84,1.84,0,0,1,1,.27,1.55,1.55,0,0,1,.61.69v-.9h.53v4.1h-.53v-.91a1.58,1.58,0,0,1-.62.69,1.81,1.81,0,0,1-1,.28,1.87,1.87,0,0,1-1-.27,1.79,1.79,0,0,1-.7-.74,2.33,2.33,0,0,1-.25-1.11A2.26,2.26,0,0,1,384.26,357.16Zm3.12.24a1.45,1.45,0,0,0-1.32-.78,1.56,1.56,0,0,0-.78.2,1.33,1.33,0,0,0-.54.56,2,2,0,0,0,0,1.76,1.38,1.38,0,0,0,.54.58,1.6,1.6,0,0,0,1.55,0,1.54,1.54,0,0,0,.55-.58,2,2,0,0,0,0-1.74Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M389.3,355.34a.36.36,0,0,1-.11-.28.33.33,0,0,1,.11-.27.37.37,0,0,1,.27-.11.4.4,0,0,1,.27.11.37.37,0,0,1,.11.27.39.39,0,0,1-.11.28.36.36,0,0,1-.27.11A.33.33,0,0,1,389.3,355.34Zm.53.88v4.1h-.52v-4.1Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M394.14,356.6a1.77,1.77,0,0,1,.46,1.32v2.4h-.51V358a1.42,1.42,0,0,0-.34-1,1.16,1.16,0,0,0-.91-.35,1.22,1.22,0,0,0-.94.37,1.53,1.53,0,0,0-.35,1.1v2.24H391v-4.1h.53v.7a1.29,1.29,0,0,1,.56-.57,1.73,1.73,0,0,1,.83-.2A1.65,1.65,0,0,1,394.14,356.6Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M395.58,360.24a.39.39,0,0,1-.11-.28.38.38,0,1,1,.76,0,.39.39,0,0,1-.11.28.39.39,0,0,1-.54,0Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M397.14,357.16a1.87,1.87,0,0,1,.71-.74,2,2,0,0,1,1-.26,2,2,0,0,1,1.25.38,1.66,1.66,0,0,1,.63,1h-.56a1.16,1.16,0,0,0-.45-.7,1.49,1.49,0,0,0-.87-.25,1.54,1.54,0,0,0-.74.19,1.35,1.35,0,0,0-.52.56,2.27,2.27,0,0,0,0,1.82,1.37,1.37,0,0,0,.52.57,1.53,1.53,0,0,0,.74.18,1.42,1.42,0,0,0,.87-.25,1.16,1.16,0,0,0,.45-.7h.56a1.66,1.66,0,0,1-.63,1,2,2,0,0,1-1.25.39,2,2,0,0,1-1-.26,1.87,1.87,0,0,1-.71-.74,2.59,2.59,0,0,1,0-2.22Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M402.47,360.12a1.83,1.83,0,0,1-.72-.74,2.42,2.42,0,0,1,0-2.22,1.92,1.92,0,0,1,.73-.74,2.23,2.23,0,0,1,2.09,0,1.86,1.86,0,0,1,.73.74,2.2,2.2,0,0,1,.27,1.11,2.23,2.23,0,0,1-.27,1.11,2,2,0,0,1-.74.74,2.21,2.21,0,0,1-1.05.26A2.11,2.11,0,0,1,402.47,360.12Zm1.79-.39a1.41,1.41,0,0,0,.56-.55,2.08,2.08,0,0,0,0-1.82,1.32,1.32,0,0,0-.55-.55,1.58,1.58,0,0,0-1.5,0,1.27,1.27,0,0,0-.55.55,2.08,2.08,0,0,0,0,1.82,1.3,1.3,0,0,0,.54.55,1.58,1.58,0,0,0,1.5,0Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M412.57,356.6a1.8,1.8,0,0,1,.45,1.32v2.4h-.51V358a1.47,1.47,0,0,0-.32-1,1.12,1.12,0,0,0-.88-.35,1.15,1.15,0,0,0-.92.38,1.59,1.59,0,0,0-.35,1.11v2.22h-.51V358a1.42,1.42,0,0,0-.33-1,1.11,1.11,0,0,0-.88-.35,1.16,1.16,0,0,0-.92.38,1.59,1.59,0,0,0-.35,1.11v2.22h-.52v-4.1h.52v.71a1.31,1.31,0,0,1,.56-.58,1.64,1.64,0,0,1,.8-.2,1.71,1.71,0,0,1,.93.25,1.42,1.42,0,0,1,.58.75,1.37,1.37,0,0,1,.57-.74,1.67,1.67,0,0,1,.91-.26A1.58,1.58,0,0,1,412.57,356.6Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M299.37,364.92H287.06V351.48h12.31Zm-11.81-.5h11.31V352H287.56Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "291.28 360.7 291.28 355.7 295.15 358.1 291.28 360.7",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "283.35 355.7 283.35 360.7 279.48 358.3 283.35 355.7",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M287.56,364.92h-12.3V351.48h12.3Zm-11.8-.5h11.3V352h-11.3Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 266.98,
    y: 333.62,
    width: 170.89,
    height: 15.13,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "551.1 559.58 368.69 559.58 413.05 524.18 595.46 524.18 551.1 559.58",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 368.69,
    y: 559.58,
    width: 182.4,
    height: 2.22,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 368.69,
    y: 559.58,
    width: 182.4,
    height: 2.22,
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M434.43,549.27H421.6l6.48-5.24h12.84Zm-11.41-.5h11.23l5.25-4.24H428.25Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M446.48,549.27H433.63l6.5-5.24H453Zm-11.43-.5H446.3l5.24-4.24H440.3Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M422.4,549.27H409.55L416,544h12.84Zm-11.43-.5h11.25l5.24-4.24H416.2Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M428.25,544.53H415.41l6.49-5.23h12.82Zm-11.43-.5h11.26l5.23-4.23H422.07Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M446.16,539.8H433.31l6.49-5.23h12.85Zm-11.43-.5H446l5.25-4.23H440Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M434.11,539.8H421.28l6.47-5.23H440.6Zm-11.42-.5h11.24l5.25-4.23H427.93Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M458.53,549.27H445.68l6.48-5.24H465Zm-11.43-.5h11.25l5.24-4.24H452.33Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M518.74,549.27H505.89l6.5-5.24h12.84Zm-11.43-.5h11.25l5.26-4.24H512.56Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M458.21,539.8H445.36l6.49-5.23h12.83Zm-11.43-.5H458l5.23-4.23H452Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M470.56,549.27H457.73l6.48-5.24h12.84Zm-11.41-.5h11.23l5.26-4.24H464.38Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M542.82,549.27H530l6.48-5.24h12.84Zm-11.41-.5h11.23l5.26-4.24H536.64Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M548.69,544.53H535.85l6.49-5.23h12.83Zm-11.43-.5h11.26l5.23-4.23H542.52Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M530.79,549.27H517.94l6.5-5.24h12.82Zm-11.43-.5h11.25l5.24-4.24H524.61Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M506.69,549.27H493.86l6.48-5.24h12.84Zm-11.41-.5h11.23l5.26-4.24H500.51Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M482.61,549.27H469.76l6.5-5.24H489.1Zm-11.43-.5h11.25l5.26-4.24H476.43Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M494.66,549.27H481.81l6.5-5.24h12.82Zm-11.43-.5h11.25l5.24-4.24H488.48Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M506.39,539.8H493.54l6.47-5.23h12.85ZM495,539.3h11.26l5.23-4.23H500.19Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M524.61,544.53H511.77l6.47-5.23h12.84Zm-11.43-.5h11.26l5.23-4.23H518.42Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M500.51,544.53H487.69l6.47-5.23H507ZM489.1,544h11.24l5.25-4.23H494.34Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M476.43,544.53H463.59l6.47-5.23H482.9ZM465,544h11.26l5.23-4.23H470.24Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M512.56,544.53H499.72l6.49-5.23H519Zm-11.43-.5h11.26l5.23-4.23H506.39Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M470.24,539.8H457.41l6.47-5.23h12.85Zm-11.42-.5h11.24l5.25-4.23H464.06Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M440.3,544.53H427.46l6.47-5.23h12.84Zm-11.43-.5h11.26l5.23-4.23H434.11Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M464.38,544.53H451.54L458,539.3h12.83ZM453,544h11.26l5.23-4.23H458.21Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M452.33,544.53H439.51L446,539.3h12.85Zm-11.41-.5h11.24l5.25-4.23H446.16Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M488.48,544.53H475.64l6.47-5.23H495Zm-11.43-.5h11.26l5.23-4.23H482.29Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M494.34,539.8H481.49l6.49-5.23h12.83Zm-11.43-.5h11.25l5.23-4.23H488.16Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M554.55,539.8H541.72l6.47-5.23H561Zm-11.41-.5h11.23l5.25-4.23H548.37Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M482.29,539.8H469.44l6.49-5.23h12.85Zm-11.43-.5h11.25l5.25-4.23H476.11Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M530.47,539.8H517.62l6.49-5.23h12.83ZM519,539.3h11.25l5.24-4.23H524.29Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M542.52,539.8H529.67l6.47-5.23H549Zm-11.43-.5h11.25l5.24-4.23H536.32Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M536.64,544.53H523.82l6.47-5.23h12.85Zm-11.41-.5h11.24l5.25-4.23H530.47Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M518.42,539.8H505.59l6.47-5.23h12.85ZM507,539.3h11.24l5.25-4.23H512.24Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M488.79,554H476l6.47-5.23h12.85Zm-11.42-.5h11.24l5.25-4.23H482.61Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M500.84,554H488l6.49-5.23h12.83Zm-11.43-.5h11.25l5.23-4.23H494.66Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M476.76,554H463.91l6.47-5.23h12.85Zm-11.44-.5h11.26l5.23-4.23H470.56Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M512.89,554H500l6.47-5.23h12.85Zm-11.44-.5h11.26l5.23-4.23H506.69Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M464.71,554H451.86l6.49-5.23h12.83Zm-11.43-.5h11.25l5.23-4.23H458.53Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M452.66,554H439.83l6.47-5.23h12.85Zm-11.42-.5h11.24l5.25-4.23H446.48Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M524.92,554H512.09l6.47-5.23h12.85Zm-11.42-.5h11.24l5.25-4.23H518.74Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M428.58,554H415.73l6.49-5.23h12.83Zm-11.43-.5H428.4l5.23-4.23H422.4Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M440.63,554H427.78l6.47-5.23H447.1Zm-11.44-.5h11.26l5.23-4.23H434.43Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M560.74,544.53H547.9l6.47-5.23h12.85Zm-11.43-.5h11.26l5.23-4.23H554.55Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M572.45,535.07H559.63l6.47-5.23h12.84Zm-11.41-.5h11.23l5.26-4.23H566.27Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M566.6,539.8H553.75l6.49-5.23h12.83Zm-11.43-.5h11.25l5.24-4.23H560.42Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M416.53,554H403.7l6.47-5.23H423Zm-11.42-.5h11.24l5.25-4.23H410.35Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M537,554H524.12l6.49-5.23h12.83Zm-11.43-.5h11.25l5.24-4.23H530.79Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M549,554H536.17l6.47-5.23h12.85Zm-11.43-.5h11.25l5.24-4.23H542.82Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M554.87,549.27H542l6.5-5.24h12.84Zm-11.43-.5h11.25l5.26-4.24H548.69Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M416.2,544.53H403.38l6.47-5.23H422.7Zm-11.41-.5H416l5.25-4.23H410Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M500.19,535.07H487.36l6.48-5.23h12.84Zm-11.41-.5H500l5.26-4.23H494Z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M512.24,535.07H499.39l6.5-5.23h12.82Zm-11.43-.5h11.25l5.24-4.23H506.06Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M488.16,535.07H475.31l6.48-5.23h12.84Zm-11.43-.5H488l5.24-4.23H482Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M524.29,535.07H511.44l6.48-5.23h12.84Zm-11.43-.5h11.25l5.24-4.23H518.09Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M548.37,535.07H535.52l6.5-5.23h12.82Zm-11.43-.5h11.25l5.24-4.23H542.19Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M536.32,535.07H523.49l6.48-5.23h12.84Zm-11.41-.5h11.23l5.26-4.23H530.14Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M476.11,535.07H463.26l6.5-5.23h12.82Zm-11.43-.5h11.25l5.24-4.23H469.93Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M410.35,549.27H397.5L404,544h12.82Zm-11.43-.5h11.25l5.24-4.24H404.17Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M422.08,539.8H409.23l6.47-5.23h12.85Zm-11.44-.5H421.9l5.23-4.23H415.88Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M560.42,535.07H547.58l6.47-5.23h12.84Zm-11.43-.5h11.25l5.24-4.23H554.22Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M404.49,554H391.65l6.47-5.23H411Zm-11.43-.5h11.26l5.23-4.23H398.3Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M427.93,535.07H415.08l6.5-5.23h12.84Zm-11.43-.5h11.25l5.25-4.23H421.75Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M452,535.07H439.18l6.48-5.23H458.5Zm-11.43-.5h11.25l5.24-4.23H445.83Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M440,535.07H427.13l6.5-5.23h12.82Zm-11.43-.5H439.8l5.24-4.23H433.8Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M464.06,535.07H451.23l6.48-5.23h12.84Zm-11.41-.5h11.23l5.26-4.23H457.88Z"
  }))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 204.75,
    y: 559.37,
    width: 12.24,
    height: 61.85,
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "270.15 621.2 270.15 516.52 216.99 559.38 216.99 621.2 270.15 621.2",
    fill: "#263238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "619.33 556.2 567.4 556.2 597.38 532.23 652.05 532.23 619.33 556.2",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M611.92,539.46l-.92-.39c.06-.16,7-16,32.75-16.86,25.33-.82,36.89-1.2,39.31-7.54a2.69,2.69,0,0,0-.16-2.74c-1.7-2.24-7.87-2.19-10.1-2H583.29v-1h89.46c.31,0,8.57-.76,11,2.37a3.68,3.68,0,0,1,.3,3.7c-2.66,7-14.43,7.35-40.22,8.19C618.72,524,612,539.31,611.92,539.46Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M618.24,534s-8.44-1.5-14.4,1.49c-3.8,1.9-7.09,8.45-9.07,13.09a3.44,3.44,0,0,0,1.82,4.51,3.33,3.33,0,0,0,1.35.28h11.31a3.44,3.44,0,0,0,2.57-1.14l11.4-12.77S622.79,534.48,618.24,534Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M611.21,549.91a12.81,12.81,0,0,1,7-12.41",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "595.46 526.4 595.46 524.18 551.1 559.58 551.1 561.79 595.46 526.4",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "595.46 526.4 595.46 524.18 551.1 559.58 551.1 561.79 595.46 526.4",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M363.14,297.47h-.3c-4-.32-6.65-6.49-6.07-14,.39-5.06,2.19-9.54,4.7-11.68a4.72,4.72,0,0,1,3.44-1.29c4,.31,6.65,6.49,6.07,14.07h0c-.39,5.05-2.19,9.52-4.69,11.66A4.9,4.9,0,0,1,363.14,297.47Zm1.47-26a3.8,3.8,0,0,0-2.49,1.06c-2.28,1.95-4,6.26-4.35,11-.52,6.78,1.84,12.72,5.15,13a3.73,3.73,0,0,0,2.72-1c2.27-2,4-6.26,4.34-11h0c.52-6.78-1.84-12.73-5.15-13Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M365,247.35s.72,13.31-1.48,19.5-5.16,10.3-5.16,13.31,4.79,6.63,4.79,12.5-10.66,34.21-13.6,39.73-1.9,7.35-5.52,7.71-12.86-4-12.86-4-5.53.73-6.26,2.93-2.58,9.94-2.58,9.94L268.63,325a53.7,53.7,0,0,0,11-18.76c3.31-10.66-1.9-27.22-1.9-27.22s-5.15-38.6,18.38-49.64,57.74-4,63.27,1.48S365,247.35,365,247.35Z",
    fill: "#f9b499"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334,340.75a61.09,61.09,0,0,1-14-15,63.38,63.38,0,0,1-10-36s-7,30,14,60Z",
    fill: "#f7a48b"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M320.49,281.56s8.82,2.57,9.93,0-2.21-3.3,1.9-4.79,13.6-7.35,13.6-13.3-11-15.81-5.53-17.3,22.45-.72,22.45-.72S351.06,251,357,253.53s20.22-.72,25.73-8.82-2.2-20.91-12.86-28-32-12.86-53-12.12-36.41,8.09-40.82,20.22,2.58,54.79,2.95,66.2,7.35,14.71,15.45,14.71,15.07-7,16.91-13.31,2.57-12.5,3.67-14S320.49,281.56,320.49,281.56Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M296,280a27.92,27.92,0,0,1-4.48,4",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M380.52,232.51s-2.46,3.69-12.28,6.14-30.68-8-53.39,2.45c-15.45,7.11-11.56,17.92-13.7,28.51",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M337.56,250.85s-8,1.22-14.12,11.65-5.51,26.38-23.93,31.3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 342.96,
    y: 251.63,
    width: 1,
    height: 52.88,
    transform: "translate(31.11 590.67) rotate(-84.02)",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M458.59,621.2c-4.43-4.35-16.11-14.67-30.81-18.19-18.81-4.46-101.26-13.87-101.26-13.87l-4-16.59s-11.65-3.6-14.33-3.6-14.79,4-41.68,9.87-75-8.44-75-8.44a36.58,36.58,0,0,0-13.09,27.94c0,11.4,1.06,20.9,2.38,22.81Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M257.6,332.31l-1.35.93C251.08,336.8,232,350,217.52,361.37c-16.92,13.3-18,37.88-18.76,57s-13.08,138.17-16,152.88,23.38,18.48,48.75,22.16,58.1-.36,73.91-7.71,19.5-7,19.5-15.09.37-26.48.37-27.94,11.4-91.57,10.66-118.05,1.48-40.82-4.77-54.07S309.09,347,288.13,340,257.6,332.31,257.6,332.31Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.61,408.68c3.95,18.59,9.06,37.19,19.14,53.48-12.21-14.23-18.12-35-19.14-53.48Z",
    fill: "#263238",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.94,463.28c5.24,6.73,11.71,12.23,17.71,18.25,3.09,3.07,3.14,3.11-.62.77a55,55,0,0,1-13.52-12.52,22.18,22.18,0,0,1-3.57-6.5Z",
    fill: "#263238",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.38,486.92c11.81,2.17,23.48,3.54,35.45,2.82-11.54,3.52-24.49,2-35.45-2.82Z",
    fill: "#263238",
    opacity: 0.2
  }))), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M261.27,319.8l-9.84,16.56s29.78,7,45.23,13.3,36.11,22.81,36.11,22.81-3.3-18.76-6.25-23.53-33.47-20.91-46-25.75S261.27,319.8,261.27,319.8Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M261.27,319.8l-9.84,16.56s29.78,7,45.23,13.3,36.11,22.81,36.11,22.81-3.3-18.76-6.25-23.53-33.47-20.91-46-25.75S261.27,319.8,261.27,319.8Z",
    fill: "#fff",
    opacity: 0.4
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M438.16,528s9.5-8.1,14-16.2,7.36-10.28,10.68-9.5a29.84,29.84,0,0,0,5.87.74s11.77-7,15.46-7.71,11,8.07,11,8.07,12.51,9.51,11,11.79-3.68,1.1-5.15,1.1-4.79-2.58-6.61-1.9-9.94,5.87-9.94,5.87,9.5,0,12.14,1.1,12.13,9.51,10.3,10.69-1.9,1.46-4,1.1a33.15,33.15,0,0,1-7.36-3.69l-9.94,1.9s5.89,6.25,7.74,7.72,8.81,3.69,5.87,5.51-5.15,1.12-8.82-1.46-11.77-6.62-13.3-6.62-5.52,5.15-12.13,7.36a64.24,64.24,0,0,1-16.55,2.2l-1.91,1.9-11-13.3-2.2-1.9Z",
    fill: "#f9b499"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M495.16,503.31s-3.31-1.9-5.51-.73-16.18,9.18-16.18,9.18",
    fill: "none",
    stroke: "#f7a48b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 468.68,
    y1: 502.95,
    x2: 462.07,
    y2: 507.36,
    fill: "none",
    stroke: "#f7a48b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M372,533.83s24.27-.36,28-2.57,12.51-8.45,12.87-11-1.9-4-5.51-2.56-13.31,5.15-14.71,5.15a52.76,52.76,0,0,1-7.72-2.21s10.66-9.5,15.07-12.14a12.08,12.08,0,0,1,11.77,0c2.58,1.48,6.61-3.31,3.3-5.88a18.15,18.15,0,0,0-11.76-4,16.19,16.19,0,0,0-5.15,1.1s-4.05-6.62-7-5.89a12.47,12.47,0,0,0-5.15,2.94,6.71,6.71,0,0,0-6.63.36C376,499.28,372.7,500,369,503s-14.35,9.92-15.82,12.5S372,533.83,372,533.83Z",
    fill: "#f9b499"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 398.08,
    y1: 499.64,
    x2: 387.78,
    y2: 505.51,
    fill: "none",
    stroke: "#f7a48b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 385.95,
    y1: 496.69,
    x2: 378.6,
    y2: 501.84,
    fill: "none",
    stroke: "#f7a48b",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M301.74,408.05s-10.31,14-13.61,25,.72,26.84,1.9,30.52S350,583.11,356.21,594.52s13.3,12.12,18.39,10.3,64.36-44.13,66.53-46.34,12.14-10.66,12.14-10.66,1.9-11.78-6.25-18-12.15-2.94-12.15-2.94l-51.48,14s-29.05-100-32.31-119.14,1.9-18-8.46-28.32a144.43,144.43,0,0,0-22.81-18.06",
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.11,558.48c2.2-2.2,12.14-10.66,12.14-10.66a25,25,0,0,0-.47-8.57c-20.7,8.19-63.12,25.16-65.59,27.65-3.29,3.27-1.64-2.47-1.64-9s-9.84,11.41-11.4,15.59-5.38-11.67-6.58-18-20.49-55.78-26.23-78.74,23.88-69.39,17.68-81.93c-.43-.83-6.66-3-14.29-5.42A38.11,38.11,0,0,0,299.87,407h0s-8.45,15.07-11.76,26.11.72,26.84,1.9,30.52c.59,2,18.3,37.26,35.33,70.8l.38-.3s32,82.31,47.3,74.65C388,599.23,439.19,560.4,441.11,558.48Z",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M248.59,621.2h8.54C244.05,596.82,172,462.14,169.51,456c-2.68-6.73-6.71-6.73-8.06-9.5s.46-14.33,0-22-25.09-78.41-31.81-90.07-17.11-10.32-17.11-10.32l-2.7,7.19,42.58,116.07Z",
    fill: "#2e3135"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M81.72,454.71C99.42,495.57,149.65,610,153.83,621.2h94.75c-11.12-20-77.23-139.54-91.23-177.27-15.21-41.22-39-114.72-44.82-119.74s-34.95-4.92-46.6-1.33-12.11,4.93-11.65,12.55S64.1,414,81.72,454.71Z",
    fill: "#3f4347"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 115.65,
    y1: 621.2,
    x2: 801.02,
    y2: 621.2,
    fill: "none",
    stroke: "#3f4347",
    strokeMiterlimit: 10
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.52,
    cy: 287.75,
    rx: 8.5,
    ry: 14,
    fill: "#f9b499"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M601.94,519.5H539.06a1,1,0,0,1-.43-1.9l12.92-6.23a1.09,1.09,0,0,1,.44,0h58a1,1,0,0,1,.61,1.78l-8.1,6.22A1,1,0,0,1,601.94,519.5Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 571.93,
    y: 472.12,
    width: 11.56,
    height: 44.04,
    fill: "#b3b3b3"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 570.12,
    y: 472.12,
    width: 15.17,
    height: 31.97,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 484.76,
    y: 325.62,
    width: 191.35,
    height: 149.67,
    fill: "#0071f2",
    "data-primary": "true"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 484.76,
    y: 325.62,
    width: 191.35,
    height: 149.67,
    fill: "#fff",
    opacity: 0.4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 494.98,
    y: 333.62,
    width: 170.89,
    height: 133.67,
    fill: "#ebebeb"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 495.02,
    y: 348.33,
    width: 171,
    height: 19.87,
    fill: "#f2f2f2"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M659.77,364.92H545.87V351.48h113.9Zm-113.4-.5h112.9V352H546.37Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M537.4,388H502.06V370.6H537.4Zm-34.84-.5H536.9V371.1H502.56Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M583.1,383H564.66v-7.34H583.1Zm-17.94-.5H582.6v-6.34H565.16Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M608.7,383H590.27v-7.34H608.7Zm-17.93-.5H608.2v-6.34H590.77Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M632.92,383H614.49v-7.34h18.43Zm-17.93-.5h17.43v-6.34H615Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M658.8,383H640.37v-7.34H658.8Zm-17.93-.5H658.3v-6.34H640.87Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M658.8,445H502.06V390.89H658.8Zm-156.24-.5H658.3V391.39H502.56Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 502.02,
    y: 452.18,
    width: 148,
    height: 0.5,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 502.02,
    y: 463.5,
    width: 134.93,
    height: 0.5,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M552.27,356.34a1.37,1.37,0,0,1,.59.6,2.09,2.09,0,0,1,.21,1v2.4h-.52V358a1.42,1.42,0,0,0-.33-1,1.18,1.18,0,0,0-.91-.35,1.22,1.22,0,0,0-.94.37,1.53,1.53,0,0,0-.36,1.1v2.24h-.52v-5.55H550v2.15a1.45,1.45,0,0,1,.58-.57,1.81,1.81,0,0,1,.85-.2A1.72,1.72,0,0,1,552.27,356.34Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M554.91,356.67v2.54a.67.67,0,0,0,.15.51.66.66,0,0,0,.5.15H556v.45h-.56a1.18,1.18,0,0,1-.83-.26,1.16,1.16,0,0,1-.27-.85v-2.54h-.57v-.45h.57v-1h.53v1H556v.45Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M557.58,356.67v2.54a.72.72,0,0,0,.14.51.71.71,0,0,0,.51.15h.47v.45h-.56a1,1,0,0,1-1.09-1.11v-2.54h-.57v-.45h.57v-1h.53v1h1.12v.45Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M560.7,356.44a1.84,1.84,0,0,1,1-.28,2,2,0,0,1,1,.26,1.85,1.85,0,0,1,.7.74,2.38,2.38,0,0,1,.25,1.1,2.45,2.45,0,0,1-.25,1.11,1.79,1.79,0,0,1-.7.74,1.9,1.9,0,0,1-1,.27,1.81,1.81,0,0,1-1-.28,1.64,1.64,0,0,1-.63-.68v2.83h-.51v-6h.51v.9A1.68,1.68,0,0,1,560.7,356.44Zm2.23.94a1.41,1.41,0,0,0-.55-.56,1.56,1.56,0,0,0-.78-.2,1.51,1.51,0,0,0-.76.2,1.4,1.4,0,0,0-.55.58,1.91,1.91,0,0,0,0,1.74,1.4,1.4,0,0,0,.55.58,1.51,1.51,0,0,0,.76.2,1.56,1.56,0,0,0,.78-.2,1.47,1.47,0,0,0,.55-.58,2,2,0,0,0,0-1.76Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M564.44,357a.39.39,0,0,1-.11-.28.38.38,0,1,1,.76,0,.39.39,0,0,1-.11.28.39.39,0,0,1-.54,0Zm0,3.26a.39.39,0,0,1-.11-.28.38.38,0,1,1,.76,0,.39.39,0,0,1-.11.28.39.39,0,0,1-.54,0Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M568.61,361.56l-2.44-8.29h.53l2.43,8.29Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M573.13,361.56l-2.45-8.29h.54l2.42,8.29Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M580.44,356.22l-1.28,4.1h-.53l-1.13-3.44-1.13,3.44h-.53l-1.28-4.1h.53l1,3.56,1.14-3.56h.53l1.13,3.57,1-3.57Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M586.54,356.22l-1.28,4.1h-.52l-1.13-3.44-1.13,3.44h-.54l-1.28-4.1h.54l1,3.56,1.15-3.56h.52l1.14,3.57,1-3.57Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M592.65,356.22l-1.28,4.1h-.53l-1.13-3.44-1.13,3.44h-.53l-1.28-4.1h.53l1,3.56,1.15-3.56H590l1.13,3.57,1-3.57Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M593.18,360.24a.39.39,0,0,1-.11-.28.38.38,0,1,1,.76,0,.39.39,0,0,1-.11.28.39.39,0,0,1-.54,0Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M594.74,357.16a1.85,1.85,0,0,1,.7-.74,2,2,0,0,1,1-.26,1.79,1.79,0,0,1,1,.27,1.61,1.61,0,0,1,.64.68v-2.34h.52v5.55h-.52v-.92a1.55,1.55,0,0,1-.62.7,1.81,1.81,0,0,1-1,.28,1.93,1.93,0,0,1-1-.27,1.77,1.77,0,0,1-.69-.74,2.33,2.33,0,0,1-.25-1.11A2.26,2.26,0,0,1,594.74,357.16Zm3.12.24a1.54,1.54,0,0,0-.55-.58,1.58,1.58,0,0,0-.77-.2,1.56,1.56,0,0,0-.78.2,1.33,1.33,0,0,0-.54.56,2,2,0,0,0,0,1.76,1.38,1.38,0,0,0,.54.58,1.56,1.56,0,0,0,.78.2,1.58,1.58,0,0,0,.77-.2,1.54,1.54,0,0,0,.55-.58,2,2,0,0,0,0-1.74Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M600.54,360.12a1.92,1.92,0,0,1-.73-.74,2.42,2.42,0,0,1,0-2.22,2,2,0,0,1,.74-.74,2.11,2.11,0,0,1,1-.26,2.14,2.14,0,0,1,1,.26,2,2,0,0,1,.74.74,2.3,2.3,0,0,1,.26,1.11,2.23,2.23,0,0,1-.27,1.11,1.88,1.88,0,0,1-.74.74,2.15,2.15,0,0,1-1,.26A2.07,2.07,0,0,1,600.54,360.12Zm1.78-.39a1.35,1.35,0,0,0,.56-.55,2.08,2.08,0,0,0,0-1.82,1.32,1.32,0,0,0-.55-.55,1.58,1.58,0,0,0-1.5,0,1.32,1.32,0,0,0-.55.55,2.08,2.08,0,0,0,0,1.82,1.32,1.32,0,0,0,.55.55,1.43,1.43,0,0,0,.74.19A1.49,1.49,0,0,0,602.32,359.73Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M610.63,356.6a1.77,1.77,0,0,1,.46,1.32v2.4h-.52V358a1.47,1.47,0,0,0-.32-1,1.12,1.12,0,0,0-.88-.35,1.16,1.16,0,0,0-.92.38,1.59,1.59,0,0,0-.35,1.11v2.22h-.51V358a1.47,1.47,0,0,0-.32-1,1.13,1.13,0,0,0-.89-.35,1.16,1.16,0,0,0-.92.38,1.59,1.59,0,0,0-.34,1.11v2.22h-.53v-4.1h.53v.71a1.29,1.29,0,0,1,.55-.58,1.78,1.78,0,0,1,1.73,0,1.44,1.44,0,0,1,.59.75,1.36,1.36,0,0,1,.56-.74,1.67,1.67,0,0,1,.91-.26A1.58,1.58,0,0,1,610.63,356.6Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M612.26,357.16a1.85,1.85,0,0,1,.7-.74,2,2,0,0,1,1-.26,1.84,1.84,0,0,1,1,.27,1.55,1.55,0,0,1,.61.69v-.9h.53v4.1h-.53v-.91a1.58,1.58,0,0,1-.62.69,1.81,1.81,0,0,1-1,.28,1.87,1.87,0,0,1-1-.27,1.79,1.79,0,0,1-.7-.74,2.33,2.33,0,0,1-.25-1.11A2.26,2.26,0,0,1,612.26,357.16Zm3.12.24a1.45,1.45,0,0,0-1.32-.78,1.56,1.56,0,0,0-.78.2,1.33,1.33,0,0,0-.54.56,2,2,0,0,0,0,1.76,1.38,1.38,0,0,0,.54.58,1.6,1.6,0,0,0,1.55,0,1.54,1.54,0,0,0,.55-.58,2,2,0,0,0,0-1.74Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M617.3,355.34a.36.36,0,0,1-.11-.28.33.33,0,0,1,.11-.27.37.37,0,0,1,.27-.11.4.4,0,0,1,.27.11.37.37,0,0,1,.11.27.39.39,0,0,1-.11.28.36.36,0,0,1-.27.11A.33.33,0,0,1,617.3,355.34Zm.53.88v4.1h-.52v-4.1Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M622.14,356.6a1.77,1.77,0,0,1,.46,1.32v2.4h-.51V358a1.42,1.42,0,0,0-.34-1,1.16,1.16,0,0,0-.91-.35,1.22,1.22,0,0,0-.94.37,1.53,1.53,0,0,0-.35,1.1v2.24H619v-4.1h.53v.7a1.29,1.29,0,0,1,.56-.57,1.73,1.73,0,0,1,.83-.2A1.65,1.65,0,0,1,622.14,356.6Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M623.58,360.24a.39.39,0,0,1-.11-.28.38.38,0,1,1,.76,0,.39.39,0,0,1-.11.28.39.39,0,0,1-.54,0Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M625.14,357.16a1.87,1.87,0,0,1,.71-.74,2,2,0,0,1,1-.26,2,2,0,0,1,1.25.38,1.66,1.66,0,0,1,.63,1h-.56a1.16,1.16,0,0,0-.45-.7,1.49,1.49,0,0,0-.87-.25,1.54,1.54,0,0,0-.74.19,1.35,1.35,0,0,0-.52.56,2.27,2.27,0,0,0,0,1.82,1.37,1.37,0,0,0,.52.57,1.53,1.53,0,0,0,.74.18,1.42,1.42,0,0,0,.87-.25,1.16,1.16,0,0,0,.45-.7h.56a1.66,1.66,0,0,1-.63,1,2,2,0,0,1-1.25.39,2,2,0,0,1-1-.26,1.87,1.87,0,0,1-.71-.74,2.59,2.59,0,0,1,0-2.22Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M630.47,360.12a1.83,1.83,0,0,1-.72-.74,2.42,2.42,0,0,1,0-2.22,1.92,1.92,0,0,1,.73-.74,2.23,2.23,0,0,1,2.09,0,1.86,1.86,0,0,1,.73.74,2.2,2.2,0,0,1,.27,1.11,2.23,2.23,0,0,1-.27,1.11,2,2,0,0,1-.74.74,2.21,2.21,0,0,1-1,.26A2.11,2.11,0,0,1,630.47,360.12Zm1.79-.39a1.41,1.41,0,0,0,.56-.55,2.08,2.08,0,0,0,0-1.82,1.32,1.32,0,0,0-.55-.55,1.58,1.58,0,0,0-1.5,0,1.27,1.27,0,0,0-.55.55,2.08,2.08,0,0,0,0,1.82,1.3,1.3,0,0,0,.54.55,1.58,1.58,0,0,0,1.5,0Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M640.57,356.6a1.8,1.8,0,0,1,.45,1.32v2.4h-.51V358a1.47,1.47,0,0,0-.32-1,1.12,1.12,0,0,0-.88-.35,1.15,1.15,0,0,0-.92.38,1.59,1.59,0,0,0-.35,1.11v2.22h-.51V358a1.42,1.42,0,0,0-.33-1,1.11,1.11,0,0,0-.88-.35,1.16,1.16,0,0,0-.92.38,1.59,1.59,0,0,0-.35,1.11v2.22h-.52v-4.1h.52v.71a1.31,1.31,0,0,1,.56-.58,1.64,1.64,0,0,1,.8-.2,1.71,1.71,0,0,1,.93.25,1.42,1.42,0,0,1,.58.75,1.37,1.37,0,0,1,.57-.74,1.67,1.67,0,0,1,.91-.26A1.58,1.58,0,0,1,640.57,356.6Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M527.37,364.92H515.06V351.48h12.31Zm-11.81-.5h11.31V352H515.56Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "519.28 360.7 519.28 355.7 523.15 358.1 519.28 360.7",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "511.35 355.7 511.35 360.7 507.48 358.3 511.35 355.7",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M515.56,364.92h-12.3V351.48h12.3Zm-11.8-.5h11.3V352h-11.3Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 494.98,
    y: 333.62,
    width: 170.89,
    height: 15.13,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M553.71,399.28a9.22,9.22,0,0,1,6.3-2,10.26,10.26,0,0,1,4.52.92,6.47,6.47,0,0,1,3.81,6,5.9,5.9,0,0,1-1.16,3.78,5.81,5.81,0,0,1-2.71,2v.14a6.4,6.4,0,0,1,3.17,2.21,6.5,6.5,0,0,1,1.16,4,7.44,7.44,0,0,1-1,3.85,6.91,6.91,0,0,1-2.92,2.62,11.72,11.72,0,0,1-11.29-1.13c-1.67-1.38-2.56-3.47-2.65-6.26h5.83a3.6,3.6,0,0,0,.88,2.45,3.2,3.2,0,0,0,2.46.89,2.78,2.78,0,0,0,2.13-.79,2.9,2.9,0,0,0,.76-2.09,2.77,2.77,0,0,0-1.08-2.44,6,6,0,0,0-3.42-.76h-1.13v-4.89h1.13a6,6,0,0,0,2.9-.61,2.29,2.29,0,0,0,1.1-2.2,2.67,2.67,0,0,0-.7-2,2.6,2.6,0,0,0-1.93-.7,2.4,2.4,0,0,0-2,.81,3.66,3.66,0,0,0-.76,2h-5.87A7.76,7.76,0,0,1,553.71,399.28Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M574.65,400.79q2.34-3.48,7.54-3.48t7.54,3.48q2.34,3.48,2.34,9.53t-2.34,9.6q-2.34,3.48-7.54,3.48t-7.54-3.48q-2.34-3.48-2.34-9.6T574.65,400.79Zm10.74,4.06a3.64,3.64,0,0,0-6.4,0,15.32,15.32,0,0,0-.77,5.47,22.82,22.82,0,0,0,.28,4,5.15,5.15,0,0,0,1.14,2.53,3.87,3.87,0,0,0,5.1,0,5,5,0,0,0,1.14-2.53,22.69,22.69,0,0,0,.29-4A15.07,15.07,0,0,0,585.39,404.85Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M596.11,417.81q3.45-2.85,5.44-4.68a22.45,22.45,0,0,0,3.36-3.83,7,7,0,0,0,1.37-3.9,3.47,3.47,0,0,0-.67-2.25,2.78,2.78,0,0,0-4.1.19,4.65,4.65,0,0,0-.76,2.83H595a10,10,0,0,1,1.29-5,7.38,7.38,0,0,1,3.2-2.95,10,10,0,0,1,4.41-1q4.18,0,6.31,2.14a7.6,7.6,0,0,1,2.13,5.59,11,11,0,0,1-2.57,7,37.56,37.56,0,0,1-6.54,6.28h9.49v4.88H595v-4.46C595.82,418.06,596.18,417.76,596.11,417.81Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M531.85,430.53v.83h-2.14v7h-1v-7h-2.14v-.83Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M538.68,435.66h-4.91a1.93,1.93,0,0,0,2,1.94,1.92,1.92,0,0,0,1.11-.31,1.61,1.61,0,0,0,.62-.83h1.1a2.62,2.62,0,0,1-1,1.44,3,3,0,0,1-1.85.56,3.11,3.11,0,0,1-1.56-.39,2.78,2.78,0,0,1-1.08-1.12,3.37,3.37,0,0,1-.4-1.68,3.58,3.58,0,0,1,.38-1.67,2.75,2.75,0,0,1,1.08-1.11,3.16,3.16,0,0,1,1.58-.39,3,3,0,0,1,1.55.39,2.57,2.57,0,0,1,1,1.05,3,3,0,0,1,.37,1.51A4.35,4.35,0,0,1,538.68,435.66Zm-1.28-1.83a1.67,1.67,0,0,0-.7-.64,2.11,2.11,0,0,0-1-.22,1.92,1.92,0,0,0-1.32.49,2,2,0,0,0-.62,1.37h3.88A1.8,1.8,0,0,0,537.4,433.83Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M548.75,432.39a2.16,2.16,0,0,1,.88.89,3,3,0,0,1,.33,1.45v3.63h-1v-3.48a2,2,0,0,0-.46-1.41,1.58,1.58,0,0,0-1.23-.49,1.66,1.66,0,0,0-1.27.51,2.12,2.12,0,0,0-.47,1.48v3.39h-1v-3.48a2,2,0,0,0-.45-1.41,1.6,1.6,0,0,0-1.23-.49,1.64,1.64,0,0,0-1.27.51,2.12,2.12,0,0,0-.47,1.48v3.39h-1v-6.15h1v.88a2,2,0,0,1,.81-.74,2.5,2.5,0,0,1,1.13-.26,2.68,2.68,0,0,1,1.37.35,2.17,2.17,0,0,1,.89,1,2,2,0,0,1,.85-1,2.53,2.53,0,0,1,1.33-.36A2.72,2.72,0,0,1,548.75,432.39Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M553.56,432.46a2.65,2.65,0,0,1,1.4-.36,2.88,2.88,0,0,1,1.48.4,2.72,2.72,0,0,1,1,1.1,3.82,3.82,0,0,1,0,3.32,2.87,2.87,0,0,1-3.92,1.19,2.6,2.6,0,0,1-.92-.88v4h-1v-9.07h1v1.13A2.49,2.49,0,0,1,553.56,432.46Zm3,1.59a1.93,1.93,0,0,0-.76-.79,2.11,2.11,0,0,0-1-.27,2,2,0,0,0-1.8,1.07,2.69,2.69,0,0,0,0,2.43,2,2,0,0,0,.76.8,2.16,2.16,0,0,0,2.09,0,2,2,0,0,0,.76-.8,2.54,2.54,0,0,0,.28-1.23A2.46,2.46,0,0,0,556.55,434.05Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M560.34,438.07a2.76,2.76,0,0,1-1.1-1.12,3.67,3.67,0,0,1,0-3.35,2.85,2.85,0,0,1,1.12-1.11,3.4,3.4,0,0,1,3.16,0,2.78,2.78,0,0,1,1.12,1.11,3.36,3.36,0,0,1,.41,1.67,3.27,3.27,0,0,1-.42,1.68,2.92,2.92,0,0,1-1.14,1.12,3.28,3.28,0,0,1-1.59.39A3.18,3.18,0,0,1,560.34,438.07Zm2.6-.77a2,2,0,0,0,.78-.77,2.45,2.45,0,0,0,.3-1.26,2.5,2.5,0,0,0-.3-1.26,1.8,1.8,0,0,0-.76-.76,2.09,2.09,0,0,0-1-.26,2.13,2.13,0,0,0-1,.26,1.75,1.75,0,0,0-.74.76,2.61,2.61,0,0,0-.29,1.26,2.71,2.71,0,0,0,.28,1.27,1.78,1.78,0,0,0,.74.77,2,2,0,0,0,1,.25A2.08,2.08,0,0,0,562.94,437.3Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M568.2,432.39a2.32,2.32,0,0,1,1.22-.3v1.06h-.27c-1.15,0-1.72.62-1.72,1.86v3.35h-1v-6.15h1v1A1.91,1.91,0,0,1,568.2,432.39Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M570.6,433.6a2.72,2.72,0,0,1,1-1.1,2.88,2.88,0,0,1,1.48-.4,2.78,2.78,0,0,1,1.41.35,2.5,2.5,0,0,1,.89.88v-1.12h1v6.15h-1v-1.15a2.53,2.53,0,0,1-.91.9,2.74,2.74,0,0,1-1.4.35,2.75,2.75,0,0,1-2.52-1.54,3.73,3.73,0,0,1,0-3.32Zm4.54.46a1.91,1.91,0,0,0-.75-.79,2,2,0,0,0-1-.28,2.11,2.11,0,0,0-1.05.27,2,2,0,0,0-.75.79,2.46,2.46,0,0,0-.28,1.21,2.54,2.54,0,0,0,.28,1.23,2.07,2.07,0,0,0,.75.8,2.18,2.18,0,0,0,2.1,0,1.93,1.93,0,0,0,.75-.8,2.5,2.5,0,0,0,.29-1.22A2.46,2.46,0,0,0,575.14,434.06Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M580,432.39a2.32,2.32,0,0,1,1.22-.3v1.06h-.27c-1.15,0-1.72.62-1.72,1.86v3.35h-1v-6.15h1v1A1.85,1.85,0,0,1,580,432.39Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M587.68,432.21,584,441.26h-1.06l1.22-3-2.48-6.08h1.13l1.93,5,1.91-5Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M595.82,438.36l-1.87-3.2h-1.23v3.2h-1v-7.83h2.53a3.26,3.26,0,0,1,1.5.31,2.11,2.11,0,0,1,.92.82,2.28,2.28,0,0,1,.3,1.18,2.31,2.31,0,0,1-.47,1.42,2.24,2.24,0,0,1-1.4.82l2,3.28Zm-3.1-4h1.5a1.73,1.73,0,0,0,1.25-.41,1.49,1.49,0,0,0,.41-1.09,1.37,1.37,0,0,0-.41-1.08,1.75,1.75,0,0,0-1.25-.38h-1.5Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M604.1,435.66h-4.92a2,2,0,0,0,.63,1.43,2.12,2.12,0,0,0,2.48.2,1.67,1.67,0,0,0,.62-.83H604a2.59,2.59,0,0,1-1,1.44,2.9,2.9,0,0,1-1.84.56,3.11,3.11,0,0,1-1.56-.39,2.8,2.8,0,0,1-1.09-1.12,3.47,3.47,0,0,1-.39-1.68,3.58,3.58,0,0,1,.38-1.67,2.73,2.73,0,0,1,1.07-1.11,3.18,3.18,0,0,1,1.59-.39,3,3,0,0,1,1.55.39,2.57,2.57,0,0,1,1,1.05,3.13,3.13,0,0,1,.37,1.51C604.14,435.24,604.12,435.45,604.1,435.66Zm-1.28-1.83a1.67,1.67,0,0,0-.7-.64,2.11,2.11,0,0,0-1-.22,1.92,1.92,0,0,0-1.32.49,2,2,0,0,0-.62,1.37h3.88A1.88,1.88,0,0,0,602.82,433.83Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M605.48,433.6a2.85,2.85,0,0,1,1-1.1,3,3,0,0,1,1.5-.4,2.81,2.81,0,0,1,1.34.34,2.4,2.4,0,0,1,.94.87v-3.26h1v8.31h-1V437.2a2.38,2.38,0,0,1-.9.91,2.71,2.71,0,0,1-1.39.35,2.82,2.82,0,0,1-1.49-.4,2.9,2.9,0,0,1-1-1.14,3.82,3.82,0,0,1,0-3.32Zm4.55.46a2,2,0,0,0-.76-.79,2,2,0,0,0-1-.28,2,2,0,0,0-1,.27,1.91,1.91,0,0,0-.75.79,2.46,2.46,0,0,0-.28,1.21,2.54,2.54,0,0,0,.28,1.23,2,2,0,0,0,.75.8,2,2,0,0,0,2.85-.8,2.5,2.5,0,0,0,.28-1.22A2.46,2.46,0,0,0,610,434.06Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M613.11,431a.66.66,0,0,1-.2-.5.64.64,0,0,1,.2-.49.65.65,0,0,1,.49-.21.63.63,0,0,1,.48.21.68.68,0,0,1,.2.49.7.7,0,0,1-.2.5.66.66,0,0,1-.48.2A.68.68,0,0,1,613.11,431Zm1,1.2v6.15h-1v-6.15Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M617.63,432.39a2.32,2.32,0,0,1,1.22-.3v1.06h-.27c-1.15,0-1.72.62-1.72,1.86v3.35h-1v-6.15h1v1A1.85,1.85,0,0,1,617.63,432.39Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M625.61,435.66h-4.92a1.93,1.93,0,0,0,2,1.94,1.9,1.9,0,0,0,1.1-.31,1.69,1.69,0,0,0,.63-.83h1.1a2.69,2.69,0,0,1-1,1.44,2.94,2.94,0,0,1-1.84.56,3.13,3.13,0,0,1-1.57-.39A2.78,2.78,0,0,1,620,437a3.37,3.37,0,0,1-.4-1.68,3.58,3.58,0,0,1,.38-1.67,2.75,2.75,0,0,1,1.08-1.11,3.18,3.18,0,0,1,1.59-.39,3.05,3.05,0,0,1,1.55.39,2.6,2.6,0,0,1,1,1.05,3,3,0,0,1,.37,1.51C625.64,435.24,625.63,435.45,625.61,435.66Zm-1.28-1.83a1.75,1.75,0,0,0-.71-.64,2.11,2.11,0,0,0-1-.22,1.92,1.92,0,0,0-1.32.49,2,2,0,0,0-.62,1.37h3.88A1.88,1.88,0,0,0,624.33,433.83Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M627,433.6a2.68,2.68,0,0,1,1.06-1.1,3.06,3.06,0,0,1,1.55-.4,3,3,0,0,1,1.87.56,2.53,2.53,0,0,1,1,1.52h-1.1a1.54,1.54,0,0,0-.61-.88,1.87,1.87,0,0,0-1.13-.33,1.81,1.81,0,0,0-1.41.6,2.46,2.46,0,0,0-.54,1.7,2.5,2.5,0,0,0,.54,1.72,1.82,1.82,0,0,0,1.41.61,1.93,1.93,0,0,0,1.13-.32,1.57,1.57,0,0,0,.61-.9h1.1a2.66,2.66,0,0,1-1,1.51,3,3,0,0,1-1.86.57,3.05,3.05,0,0,1-1.55-.39A2.64,2.64,0,0,1,627,437a3.81,3.81,0,0,1,0-3.36Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M635.05,433.05v3.63a.83.83,0,0,0,.19.63,1,1,0,0,0,.66.19h.75v.86h-.92a1.85,1.85,0,0,1-1.28-.39,1.73,1.73,0,0,1-.42-1.29v-3.63h-.8v-.84h.8v-1.55h1v1.55h1.6v.84Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M762.58,543.6a325.84,325.84,0,0,0-.47-34.66,442.28,442.28,0,0,0-10.86-70.62c-3-13.06-6.76-25.91-10.64-38.74-.12-.4-.73-.28-.63.12,12,45.24,21.88,91.93,21.16,139-.18,13.22-1.7,26.09-3,39.17,0,.35.54.49.62.13C761.31,566.82,762.12,555.09,762.58,543.6Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M740,399.75s-18.21,46.2-14.13,57.06S738.33,470,738.33,470,727.2,485.9,735,500.85,760.1,515.06,761.2,532C761.2,531.91,762.16,461.22,740,399.75Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M759.23,502.73a.57.57,0,0,0,0-.26,423.53,423.53,0,0,0-17.66-92.93c0-.08-.17,0-.14,0q5.39,20.26,9.56,40.75a20.23,20.23,0,0,0-8.69-4.84c-.07,0-.09.07,0,.09a22.9,22.9,0,0,1,9,6c.55,2.64,1.06,5.28,1.55,8-4.06-4.55-9.7-6.8-15.35-8.94-.08,0-.12.09,0,.11,5.88,2.4,11.73,5.48,15.72,10.58q2.09,11.51,3.65,23.08A21.9,21.9,0,0,0,746,478.2c-.11,0-.19.15-.06.19a22.87,22.87,0,0,1,11,7.05H757c.36,2.71.7,5.44,1,8.15A28.24,28.24,0,0,0,750.4,489c-.06,0-.1.09,0,.12a26,26,0,0,1,7.62,5.05h.11c.29,2.64.59,5.18.86,7.78a36.93,36.93,0,0,0-15.44-11,.09.09,0,0,0-.06.18,40.48,40.48,0,0,1,15.21,11.72.36.36,0,0,0,.38.12q.6,5.94,1,11.9s.1.07.1,0C759.83,510.89,759.62,506.8,759.23,502.73Z",
    fill: "#3f4347"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M744.6,440.9a22.83,22.83,0,0,0-10.94-3.41.07.07,0,0,0-.06.07.06.06,0,0,0,.06.06,44.23,44.23,0,0,1,10.82,3.53C744.61,441.22,744.73,441,744.6,440.9Z",
    fill: "#3f4347"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M746.81,489.82A23.1,23.1,0,0,0,738.6,487a.08.08,0,1,0,0,.16,31.35,31.35,0,0,1,8.12,2.84C746.82,490.06,746.91,489.87,746.81,489.82Z",
    fill: "#3f4347"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M810.43,457.57A124.29,124.29,0,0,0,789.36,476,75.87,75.87,0,0,0,774.59,501a187.42,187.42,0,0,0-11,59.93,145.11,145.11,0,0,0,3.24,33.7.32.32,0,0,0,.38.26.32.32,0,0,0,.25-.38,188.89,188.89,0,0,1,.33-58.9c3.13-19.12,8-39.91,20.18-55.45,6.62-8.45,14.87-15.1,23-22C811.42,457.84,810.88,457.25,810.43,457.57Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M766.23,547.2a113.54,113.54,0,0,1,15.37-19.63c9.1-9.11,16.77-15.57,18-21.59s-9.13-10.46-9.13-10.46,12.61,2.26,16.05-3,5.11-35.92,5.11-35.92S788.72,473,778,495.89,766.23,547.2,766.23,547.2Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M803.68,464.43c-9.64,9.48-19.34,19.57-25,32a127.36,127.36,0,0,0-5.06,13.23h0c-.29.9-.6,1.81-.88,2.72a.38.38,0,0,0,0,.15,263,263,0,0,0-6.52,28.3s.1.09.11,0c1-4.78,2.08-9.6,3.29-14.42h.14a20.14,20.14,0,0,1,6-1.53c.13,0,.12-.25,0-.24a22,22,0,0,0-6,1.09c1.11-4.34,2.32-8.67,3.68-12.94A63.52,63.52,0,0,1,787.06,511V511a51.61,51.61,0,0,0-13.35,1.14c.22-.73.47-1.46.72-2.18a67.62,67.62,0,0,1,9.05-1.54m0-.1a44.07,44.07,0,0,0-8.86,1.08c1.25-3.69,2.64-7.33,4.1-10.87a62.94,62.94,0,0,1,4.32-8.41,54,54,0,0,1,7.34-1.32c.07,0,.07-.12,0-.12a19.9,19.9,0,0,0-7,.75c1.2-1.94,2.48-3.84,3.82-5.7h0c5.14-1.13,10.35-2.19,15.61-1.2.08,0,.12-.15,0-.16-5-1.32-10-.55-15,.42.54-.72,1.09-1.43,1.66-2.14a34.07,34.07,0,0,1,9.61-1.51c.06,0,.07-.1,0-.1a25.07,25.07,0,0,0-9,.79c4.25-5.29,8.94-10.25,13.58-15.15.28-.29.12-.37-.12-.2Z",
    fill: "#3f4347"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M803.43,485.31a21.08,21.08,0,0,0-4.56-.16.18.18,0,0,0-.12.21.16.16,0,0,0,.12.12c1.51,0,3-.08,4.54,0a.09.09,0,0,0,.07-.11S803.46,485.32,803.43,485.31Z",
    fill: "#3f4347"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M786.93,515a20.8,20.8,0,0,0-7.06,1.42v.11c2.34-.56,4.69-.79,7.06-1.18a.18.18,0,0,0,.17-.18A.18.18,0,0,0,786.93,515Z",
    fill: "#3f4347"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M782,504.76a15.15,15.15,0,0,0-3,.27c-.09,0-.09.18,0,.18a15.8,15.8,0,0,0,3-.14C782.17,505,782.17,504.76,782,504.76Z",
    fill: "#3f4347"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M699.07,490.07a103.63,103.63,0,0,1,21.3,10A63.63,63.63,0,0,1,738.12,517a157.38,157.38,0,0,1,22.82,45.95,122.51,122.51,0,0,1,5.17,28,.27.27,0,0,1-.33.21.28.28,0,0,1-.21-.21,159.26,159.26,0,0,0-13.88-47.6c-7-14.75-15.73-30.42-29.1-40.2-7.31-5.29-15.52-8.8-23.71-12.47C698.33,490.52,698.63,489.92,699.07,490.07Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M755.54,552.4a95.51,95.51,0,0,0-17-12.33c-9.48-5.29-17.19-8.73-19.53-13.33s5-10.58,5-10.58-9.68,4.74-13.69,1.26-12.44-27.89-12.44-27.89,22.33,7.93,36.29,24.05S755.54,552.4,755.54,552.4Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M754.33,547.37c-11.17-21-26.08-39.94-46.51-52.46h0a103,103,0,0,1,14.95,11.7,23.78,23.78,0,0,0-12,2.53.08.08,0,0,0,0,.11.07.07,0,0,0,.06,0,33,33,0,0,1,12.36-2.09h.13c.73.69,1.44,1.39,2.15,2.09a37.55,37.55,0,0,0-6.41.86m0,.08a33.39,33.39,0,0,1,6.77-.55,141.28,141.28,0,0,1,10.58,12,10.76,10.76,0,0,0-4.48.32.09.09,0,0,0,0,.12.08.08,0,0,0,0,.05,23.15,23.15,0,0,1,4.78-.06c.63.78,1.23,1.54,1.84,2.34A42.68,42.68,0,0,0,725,525.71v.11a53.72,53.72,0,0,1,13.92-.92c.57.76,1.11,1.54,1.67,2.3a29.69,29.69,0,0,0-8.07.93c-.1,0-.08.18,0,.16a31.32,31.32,0,0,1,8.36-.65q3.61,5,6.92,10.12a7.61,7.61,0,0,0-3.55.21m0,.09a15.76,15.76,0,0,1,3.82.19c2,3.09,4,6.22,5.77,9.37.25.23.69,0,.5-.25Z",
    fill: "#3f4347"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M737,530a17,17,0,0,0-6.5.79m0,.1a50,50,0,0,1,6.46-.66c.18,0,.18-.22,0-.23Z",
    fill: "#3f4347"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M717.5,504.42a12,12,0,0,0-3,.17.09.09,0,0,0-.09.09.1.1,0,0,0,.09.1c1-.11,2-.07,2.94-.1a.13.13,0,0,0,.16-.1A.13.13,0,0,0,717.5,504.42Z",
    fill: "#3f4347"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "784.34 621.73 733.93 621.73 741.11 569.07 742.95 555.58 775.31 555.58 777.14 569.07 784.34 621.73",
    fill: "#3f4347"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "777.14 569.07 741.11 569.07 742.95 555.58 775.31 555.58 777.14 569.07",
    fill: "#2e3135"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 738.32,
    y: 550.89,
    width: 41.62,
    height: 11.44,
    fill: "#3f4347"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 458.3,
    y: 218.58,
    width: 12.05,
    height: 6.83,
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 456.59,
    y: 216.28,
    width: 15.46,
    height: 4.47,
    fill: "#0071f2",
    "data-primary": "true"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 442.03,
    y: 225.9,
    width: 4.64,
    height: 7.33,
    transform: "translate(-32.18 381.44) rotate(-45)",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 438.02,
    y: 224.52,
    width: 7.38,
    height: 4.79,
    transform: "translate(-31.08 378.8) rotate(-45)",
    fill: "#0071f2",
    "data-primary": "true"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 480.63,
    y: 227.23,
    width: 7.33,
    height: 4.64,
    transform: "translate(-20.47 409.68) rotate(-45)",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 484.53,
    y: 223.23,
    width: 4.79,
    height: 7.38,
    transform: "translate(-17.84 410.77) rotate(-45)",
    fill: "#0071f2",
    "data-primary": "true"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 464.31,
    cy: 253.83,
    r: 29.3,
    transform: "translate(127.69 662.12) rotate(-79.16)",
    fill: "#0071f2",
    "data-primary": "true"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.97,
    cy: 253.36,
    r: 27.96,
    fill: "#0071f2",
    "data-primary": "true"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 463.97,
    cy: 253.36,
    r: 27.96,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 463.65,
    cy: 255.11,
    r: 24.59,
    fill: "#fff"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 464.08,
    y: 230.82,
    width: 0.48,
    height: 3.74,
    fill: "#c7c7c7"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 453.57,
    y: 233.63,
    width: 0.48,
    height: 3.74,
    transform: "translate(-56.95 258.46) rotate(-30)",
    fill: "#c7c7c7"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 445.86,
    y: 241.32,
    width: 0.48,
    height: 3.74,
    transform: "translate(12.44 507.93) rotate(-60)",
    fill: "#c7c7c7"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 441.42,
    y: 253.48,
    width: 3.74,
    height: 0.48,
    fill: "#c7c7c7"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 444.23,
    y: 263.97,
    width: 3.74,
    height: 0.48,
    transform: "translate(-72.34 258.27) rotate(-29.98)",
    fill: "#c7c7c7"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 451.93,
    y: 271.68,
    width: 3.74,
    height: 0.48,
    transform: "translate(-8.41 529.29) rotate(-60.04)",
    fill: "#c7c7c7"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 464.08,
    y: 272.87,
    width: 0.48,
    height: 3.74,
    fill: "#c7c7c7"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 474.59,
    y: 270.03,
    width: 0.48,
    height: 3.74,
    transform: "translate(-72.34 273.85) rotate(-30)",
    fill: "#c7c7c7"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 482.29,
    y: 262.33,
    width: 0.48,
    height: 3.74,
    transform: "translate(12.46 549.98) rotate(-60)",
    fill: "#c7c7c7"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 483.48,
    y: 253.48,
    width: 3.74,
    height: 0.48,
    fill: "#c7c7c7"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 480.66,
    y: 242.97,
    width: 3.74,
    height: 0.48,
    transform: "translate(-56.96 273.75) rotate(-29.99)",
    fill: "#c7c7c7"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 472.97,
    y: 235.27,
    width: 3.74,
    height: 0.48,
    transform: "translate(33.52 529.06) rotate(-60.01)",
    fill: "#c7c7c7"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.5 235.86 465.6 255.19 463.11 255.15 463.83 235.85 464.5 235.86",
    fill: "#2f2e41",
    "data-secondary": "true"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M465.17,253.72a.85.85,0,1,1-.85-.85.85.85,0,0,1,.85.85Z",
    fill: "#0071f2",
    "data-primary": "true"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M544.1,326.11a.54.54,0,0,1-.3-.1l-4.57-3.36a.51.51,0,0,1-.11-.7.5.5,0,0,1,.7-.1l4.23,3.1,4.12-4.06a.5.5,0,0,1,.71,0,.51.51,0,0,1,0,.71L544.45,326A.5.5,0,0,1,544.1,326.11Z",
    fill: "#2f2e41",
    "data-secondary": "true"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemporal);
export default __webpack_public_path__ + "static/media/temporal.abc91e0f3c9e408def16230020a033ea.svg";
export { ForwardRef as ReactComponent };